/**
 * Public site origin for blog preview/permalinks. Single source of truth for
 * both the slug preview line and the "Preview" buttons.
 *
 * Set `VITE_SITE_URL` in the root `.env` to target an environment whose data
 * matches what this admin writes - e.g. `http://localhost:3001` for the local
 * apps/website dev server, or your staging origin. Falls back to the production
 * domain when unset.
 */
export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://www.utazzo.com';

/** Public URL for a blog post given its slug. */
export const blogPublicUrl = (slug: string): string => `${SITE_URL}/blog/${slug}`;
